import { StatusCodes } from 'http-status-codes'
import type { AgentUser } from '../../models/AgentUser'

export const getAgentClient = async (): Promise<AgentUser> => {
  try {
    const res = await fetch(`/api/web-shop/agent`, {
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        bypassfailover: 'true',
      },
    })

    const resText = await res.text()

    if (!res.ok && res.status >= StatusCodes.INTERNAL_SERVER_ERROR) {
      throw new Error(res.statusText)
    }

    return resText ? JSON.parse(resText) : undefined
  } catch (error: any) {
    console.error(error, 'something went wrong getting agent')
    throw error
  }
}
